// extracted by mini-css-extract-plugin
module.exports = {"goodsList":"styles_goodsList__wkMqE"};